import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

const getDayAndTime = (value) => {
  if (!value) return { day: null, time: null };
  const day = value.split("T")[0];
  const time = value.split("T")[1].split("Z")[0];
  return { day, time };
};

const GOIFieldTimestamp = ({ disabled, value, inputData }) => {
  const { onInputValueChange } = useObjectInput();

  const { day, time } = getDayAndTime(value);

  const handleValueChange = (key, value) => {
    if (!value) return;
    let selectedDay = day;
    let selectedTime = time;

    if (key === "day") {
      selectedDay = value;
    } else {
      selectedTime = value;
    }

    onInputValueChange(inputData.id, `${selectedDay}T${selectedTime}Z`);
  };

  return (
    <div>
      <input
        type="date"
        defaultValue={day}
        disabled={disabled}
        onChange={(e) => handleValueChange("day", e.target.value)}
      />
      <input
        type="time"
        defaultValue={time}
        disabled={disabled}
        className="mt-8"
        onChange={(e) => handleValueChange("time", e.target.value)}
      />
    </div>
  );
};

export default GOIFieldTimestamp;
